import {
  FaireDirectSignUpTypes,
  SignUpType,
} from "@faire/deprecated-retailer-visitor-shared/lib/popSignUp";
import { QueryParameters as SignUpParams } from "@faire/web-api--source/routes/www/welcome/r/personal";
import { useQueryParams } from "@faire/web/ui/hooks/useQueryParams";
import { useMemo } from "react";

export const useSignUpQueryParams = () => {
  const queryParams = useQueryParams(SignUpParams.parse);
  const isRetailerLeadAds = queryParams.signUp === SignUpType.RETAILER_LEAD_ADS;
  const isFromFacebook = queryParams.signUp === SignUpType.FACEBOOK;
  const isTradeshow = queryParams.signUp === SignUpType.TRADESHOW;
  const isRetailerSubUser = queryParams.signUp === SignUpType.RETAILER_SUBUSER;

  const isWidgetv1 = queryParams.signUp === SignUpType.WIDGET;
  const isWidgetv2 = queryParams.signUp === SignUpType.WIDGET_V2;
  const isFromWidget = isWidgetv1 || isWidgetv2;
  const isFaireDirectRequireEmailAddress =
    queryParams.signUp === SignUpType.FAIRE_DIRECT_REQUIRE_EMAIL;

  const isFaireDirectCreditEligible = queryParams.signUp
    ? FaireDirectSignUpTypes.includes(queryParams.signUp as SignUpType)
    : false;

  return useMemo(
    () => ({
      queryParams,
      isWidgetv1,
      isWidgetv2,
      isFaireDirectRequireEmailAddress,
      isFromWidget,
      isRetailerLeadAds,
      isFromFacebook,
      isTradeshow,
      isRetailerSubUser,
      isFaireDirectCreditEligible,
    }),
    [
      isFromFacebook,
      isFromWidget,
      isFaireDirectRequireEmailAddress,
      isRetailerLeadAds,
      isRetailerSubUser,
      isTradeshow,
      isWidgetv1,
      isWidgetv2,
      queryParams,
      isFaireDirectCreditEligible,
    ]
  );
};
